module.exports = __webpack_public_path__ + "static/media/binary-roots-small.16f48d33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/binary-roots-small.jpg
// module id = 401
// module chunks = 0